import { Form, Input, Select } from 'antd';

// Generic field renderer driven by the registry's field schema. Keeps
// per-EHR pages free of hard-coded form layouts.
//
// Props:
//   - fields: Array<FieldSchema>
//   - namePath: form name prefix (e.g. ['credentials'] -> registered as
//     ['credentials', key]). Use [] (default) to register at top-level.
//   - disabled: boolean (read-only after save)
//
// FieldSchema:
//   {
//     key:          string,             // payload field name
//     label:        string,
//     type?:        'text' | 'password' | 'select',  // default 'text'
//     placeholder?: string,
//     required?:    boolean,            // default true
//     helperText?:  string,
//     defaultValue?: any,               // antd Form.Item initialValue
//     options?:     Array<{ value, label }>,   // when type === 'select'
//     showSearch?:  boolean,            // when type === 'select', default true
//   }
const FieldsBlock = ({ fields, namePath = [], disabled = false }) => {
  if (!Array.isArray(fields) || fields.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
      {fields.map((field) => {
        const required = field.required !== false;
        const commonProps = {
          placeholder: field.placeholder,
          disabled,
        };

        let control;
        if (field.type === 'select') {
          control = (
            <Select
              {...commonProps}
              showSearch={field.showSearch !== false}
              options={field.options || []}
              optionFilterProp="label"
              allowClear={!required}
            />
          );
        } else if (field.type === 'password') {
          control = <Input.Password {...commonProps} autoComplete="off" />;
        } else {
          control = <Input {...commonProps} autoComplete="off" />;
        }

        return (
          <Form.Item
            key={field.key}
            name={[...namePath, field.key]}
            label={field.label}
            extra={field.helperText}
            initialValue={field.defaultValue}
            rules={
              required
                ? [{ required: true, message: `${field.label} is required` }]
                : undefined
            }
          >
            {control}
          </Form.Item>
        );
      })}
    </div>
  );
};

export default FieldsBlock;
